import React, { useState, useContext, useEffect } from "react";
import "../Styles/MemberProfilePage.css"; // Import CSS styles
import MpCoverImageUploader from "../Utils/CoverImageUploader";
import MPFeedContent from "../Utils/MemberProfile/MemberProfileFeedData";
import { ThemeContext } from "../../../../context/ThemeContext";

const MemberProfilePage = ({ userId }) => {
  const [coverImage, setCoverImage] = useState("/assets/images/login_page_img2.jpg");
  const { theme } = useContext(ThemeContext);

  useEffect(() => {
    import(`../Styles/themes/${theme}/themes.css`).then(() => {
      console.log(`Loaded ${theme} styles for UserProfile`);
    }).catch(() => {
      console.error(`Theme CSS not found for ${theme}`);
    });
  }, [theme]);

  return (
    <div className="mp-page-grid">
      <div className="mp-page-grid-upper">
            <MpCoverImageUploader coverImage={coverImage} setCoverImage={setCoverImage} userId={userId}/>
      </div>

      <div className="mp-page-grid-lower">
        <MPFeedContent userId={userId}/>
      </div>
        <div>
          <p className="mp-copyright">
            Oowlet - A Hybrid Model Social Network, Copyright © InitiumNet Technology Pvt Ltd.
          </p>
        </div>
    </div>
  );
};

export default MemberProfilePage;

